module.exports = __webpack_public_path__ + "img/europa-bg.a6cf6813.jpg";